/*
 * @Date: 2021-05-28 10:40:17
 * @LastEditors: zhangyi
 * @LastEditTime: 2021-05-28 15:36:53
 * @Description: file content
 * @FilePath: \trainVideo\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
// 路由懒加载
const commonLogin = () => import("../views/windows.vue");
const wx = () => import("../views/qrcode/index.vue");
Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/windows" },
  {
    path: "/windows",
    component: commonLogin,
  },
  {
    path: "/wx",
    component:wx,
  },

];

const router = new VueRouter({
  routes
});

export default router;
